import { useCallback } from 'react';
import { formatDateTimeWithTZ } from '../lib/utils';

export const useAdminExports = ({ adminUsers, adminReviews, adminVisitEvents = [] }) => {
  const downloadCsv = useCallback((filename, headers, rows) => {
    const escapeValue = (value) => {
      if (value === null || value === undefined) return '';
      const stringValue = String(value).replace(/"/g, '""');
      return `"${stringValue}"`;
    };
    const csvContent = [
      headers.map(escapeValue).join(','),
      ...rows.map((row) => row.map(escapeValue).join(','))
    ].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  const exportAdminUsersCsv = useCallback(() => {
    const headers = ['Nombre', 'Email', 'Tipo', 'Bloqueado', 'Bloqueado hasta', 'Razón', 'Última conexión'];
    const rows = (adminUsers || []).map((userItem) => [
      userItem.name || '',
      userItem.email || '',
      userItem.user_type || '',
      userItem.blocked ? 'Sí' : 'No',
      userItem.blocked_until ? formatDateTimeWithTZ(userItem.blocked_until) : '',
      userItem.blocked_reason || '',
      userItem.last_connection ? formatDateTimeWithTZ(userItem.last_connection) : ''
    ]);
    downloadCsv('admin_usuarios.csv', headers, rows);
  }, [adminUsers, downloadCsv]);

  const exportAdminReviewsCsv = useCallback(() => {
    const headers = ['Cliente', 'Barbería', 'Rating', 'Comentario', 'Fecha', 'Flag'];
    const rows = (adminReviews || []).map((review) => [
      review.client_name || '',
      review.barbershop_id || '',
      review.rating || 0,
      review.comment || '',
      review.created_at ? formatDateTimeWithTZ(review.created_at) : '',
      review.flagged ? 'Sí' : 'No'
    ]);
    downloadCsv('admin_resenas.csv', headers, rows);
  }, [adminReviews, downloadCsv]);

  const exportAdminVisitsCsv = useCallback(() => {
    const headers = ['Fecha', 'Tipo de evento', 'ID'];
    const rows = (adminVisitEvents || []).map((ev) => [
      ev.created_at ? formatDateTimeWithTZ(ev.created_at) : '',
      ev.event_type === 'page_visit' ? 'Visita' : ev.event_type === 'click_login' ? 'Clic Iniciar Sesión' : 'Registro',
      ev.id || ''
    ]);
    downloadCsv('admin_visitas.csv', headers, rows);
  }, [adminVisitEvents, downloadCsv]);

  return { exportAdminUsersCsv, exportAdminReviewsCsv, exportAdminVisitsCsv };
};
